import { render, staticRenderFns } from "./stuclassmobile.vue?vue&type=template&id=32b5c1d8&scoped=true&"
import script from "./stuclassmobile.vue?vue&type=script&lang=js&"
export * from "./stuclassmobile.vue?vue&type=script&lang=js&"
import style0 from "./stuclassmobile.vue?vue&type=style&index=0&id=32b5c1d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5c1d8",
  null
  
)

export default component.exports